import { useEffect, useState, useCallback } from 'react';
import { useVisibilityAwareInterval } from './useVisibilityAwareInterval';

export const useVersionCheck = (checkIntervalMs: number = 60000) => {
  const [newVersionAvailable, setNewVersionAvailable] = useState(false);

  const checkVersion = useCallback(async () => {
    try {
      const response = await fetch(`/version.json?t=${Date.now()}`);
      if (!response.ok) return;
      const data = await response.json();
      if (data.hash && data.hash !== __APP_BUILD_HASH__) {
        setNewVersionAvailable(true);
      }
    } catch {
      // Silently fail
    }
  }, []);

  useEffect(() => {
    if (import.meta.env.DEV) return;
    const timeout = setTimeout(checkVersion, 5000);
    return () => clearTimeout(timeout);
  }, [checkVersion]);

  // Periodic check - pauses when tab is hidden
  useVisibilityAwareInterval(
    checkVersion,
    import.meta.env.DEV ? null : checkIntervalMs
  );

  const refreshPage = useCallback(() => {
    window.location.reload();
  }, []);

  return { newVersionAvailable, refreshPage };
};
